import { render, staticRenderFns } from "./ModalEmitirRelatorio.vue?vue&type=template&id=85b32d72&scoped=true"
import script from "./ModalEmitirRelatorio.vue?vue&type=script&lang=ts"
export * from "./ModalEmitirRelatorio.vue?vue&type=script&lang=ts"
import style0 from "./ModalEmitirRelatorio.vue?vue&type=style&index=0&id=85b32d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b32d72",
  null
  
)

export default component.exports